import styled, { css } from 'styled-components';
import { Theme } from '../theme';
import { rgba } from '../../utils/polished';

export type NotificationVariation = 'normal' | 'secondary' | 'error' | 'warning';

export function getVariationColor(variation: NotificationVariation, theme: Theme) {
  switch (variation) {
    case 'normal':
    default:
      return theme.vars.newColor.green2;
    case 'secondary':
      return theme.vars.newColor.darkGS2;
    case 'error':
      return theme.vars.newColor.red2;
    case 'warning':
      return theme.vars.newColor.orange2;
  }
}

export function getVariationIcon(variation: NotificationVariation) {
  switch (variation) {
    case 'normal':
    default:
      return 'check';
    case 'secondary':
      return 'info-circle';
    case 'error':
      return 'ban';
    case 'warning':
      return 'exclamation-triangle';
  }
}

export const NotificationElement = styled.div<{ variation?: NotificationVariation; isOpen?: boolean }>`
  background-color: ${({ theme }) => theme.vars.newColor.white};
  border: 1px solid ${({ theme }) => theme.vars.newColor.lightGS1};
  border-left: none;
  box-shadow: ${({ theme }) => `0px 10px 20px ${rgba(theme.vars.newColor.black, 0.15)}`};
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  justify-content: space-between;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  padding: 0.8rem 2.5rem;
  position: fixed;
  right: 2rem;
  top: 8.5rem;
  transition: opacity 0.1s ease-in;
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  width: 39.5rem;
  z-index: 1060;

  &:after {
    background-color: ${({ theme, variation }) => getVariationColor(variation, theme)};
    content: '';
    height: calc(100% + 2px);
    left: -0.5rem;
    position: absolute;
    top: -1px;
    width: 0.5rem;
  }

  @media screen and (max-width: 800px) {
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
  }
`;

export const MessageElement = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`;

export const AvatarWrapper = styled.div<{ collapsible?: boolean }>`
  padding-right: 2rem;
  ${({ collapsible }) => {
    return collapsible
      ? css`
          justify-content: center;
          flex-direction: column;
          display: flex;
        `
      : null;
  }}
`;

export const NotificationHead = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
`;

export const NotificationIcon = styled.div`
  align-items: center;
  color: ${({ theme }) => theme.vars.newColor.darkGS2};
  display: flex;
  height: 3.2rem;
  margin-left: 2rem;
  padding: 0.5rem;

  :hover {
    cursor: pointer;
  }
`;

export const NotificationBody = styled.div`
  font-size: 14px;
  font-weight: normal;
  padding-left: calc(32px + 2rem);
  padding-top: ${({ theme }) => theme.designToken.spacing3};
  white-space: pre-wrap;
  max-height: calc(${({ theme }) => theme.designToken.spacing10} * 3);
  overflow-y: auto;
`;
